import React from 'react'

const ShopMaintain = () => {
  return (
    <div>ShopMaintain</div>
  )
}

export default ShopMaintain